var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('zf-funnel-step',{attrs:{"title":"Anbieter","explanation":"Bitte wähle den Hersteller bzw. den Betreiber des Geräts aus","remoteData":_vm.deviceProviders}},[_c('zf-option-selection',{attrs:{"options":_vm.providerOptions},on:{"option-selected":function($event){return _vm.onProviderSelected($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }